
























































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { QuestelServicesClient } from '@questelservices/common';
import { DxButton, DxTextBox, DxSelectBox, DxLoadPanel, DxTabs, DxLookup,DxTagBox } from 'devextreme-vue';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import DataSource from "devextreme/data/data_source";
import notify from 'devextreme/ui/notify';
import { confirm, alert } from 'devextreme/ui/dialog';
import { ClientDto } from '../../models/client/ClientDto';
import _ from 'lodash';
import { AgentDto } from '../../models/agent/AgentDto';
import { BatchDetailsDto } from '../../models/batch/BatchDetailsDto';
import { ClientService } from '../../service/ClientService';
import { BatchService } from '../../service/BatchService';
import { ReportService } from '../../service/ReportService';
import { BrowseSelectionDataDto } from '../../models/browse-mode/BrowseSelectionDataDto';
import { SelectOption } from '../../models/SelectOption';
import CustomStore from 'devextreme/data/custom_store';
import { ClientAgentAliasDto } from '../../models/client-agent/ClientAgentAliasDto';
import Lookup from 'devextreme/ui/lookup';
import FileSaver, { saveAs } from 'file-saver';
import { FileHelpers } from '@questelservices/common-vue';
import { ReportTypeEnum } from '../../models/ReportTypeEnum';
import TagBox from "devextreme/ui/tag_box";

@Component({
    components: {
        DxButton,
        DxTextBox,
        DxPopup,
        DxToolbarItem,
        DxSelectBox,
        DxLookup,
        DxLoadPanel,
        DxTabs,
        DxTagBox
    }
})
export default class ReportOnDemand extends Vue {
    public $refs: Vue['$refs'] & {
      clientAnalysisRef?: Lookup;
      clientAuditorRef?: Lookup;
      batchAnalysisRef?: Lookup;
      batchAuditorRef?: Lookup;
      agentsRef?: TagBox;
    } = {};

    private showDialog: boolean = false;
    private selectedTab: number = 0;
    private selectedAnalysisClient: string | null = null;
    private selectedAnalysisClientName: string = '';
    private selectedAnalysisBatchId: string | null = null;
    private selectedAnalysisBatchName: string = '';
    private selectedAnalysisClientData: Array<BrowseSelectionDataDto> = [];
    private selectedAuditClient: string | null = null;
    private selectedAuditClientName: string = '';
    private selectedAuditAgents: Guid[] = [];
    private selectedAuditBatchId: string | null = null;
    private selectedAuditBatchName: string = '';
    private selectedAuditClientData: Array<BrowseSelectionDataDto> = [];
    private clientService: ClientService;
    private batchService: BatchService;
    private client: QuestelServicesClient;
    private reportService: ReportService;
    private downloadInProgress: boolean = false;
    private tabs = [
        { id: 0, text: 'Monthly Reports' }
    ];

    get clientAnalysisStore(): CustomStore {
      return this.clientStore();
    }

    constructor() {
        super();
        this.clientService = new ClientService();
        this.batchService = new BatchService();
        this.reportService = new ReportService();
        this.client = new QuestelServicesClient(this.$store, '');
    }

    get clientAuditStore(): CustomStore {
      return this.clientStore();
    }

    get batchSelectionStore() :CustomStore {
      this.selectedAnalysisBatchId = null;
      return this.batchAgentStore(this.selectedAnalysisClient);
    }

    get batchAuditSelectionStore() : CustomStore {
      this.selectedAuditBatchId = null;
      return this.batchAgentStore(this.selectedAuditClient);
    }

    get AgentStore() : CustomStore {
      this.selectedAuditAgents = [];
      return this.batchAgentStore(this.selectedAuditClient, 'agent');
    }

    clientStore(): CustomStore {
      return new CustomStore({
        loadMode: 'raw',
        load: (options): Promise<any> => {
          return this.clientService.getAll();
        }
      });
    }
    batchAgentStore(clientId : string| null = null, type: 'batch' | 'agent' = 'batch'): CustomStore {
    return new CustomStore({
          loadMode: 'raw',
          load: (options): Promise<any> => {
            if (clientId) {
              return this.reportService.getReportOptions(clientId)
                .then(data => {
                  var result = data.map(x => {
                    if(type === 'batch') {
                        return {
                          text: x.BatchName,
                          value: x.BatchId
                       } 
                    }
                    else {
                      return {
                          text: x.AgentName,
                          value: x.AgentId
                       } 
                    }
                    
                  });

                  return this.sortSelectOptions(result, type === 'batch');
                })
                .catch(this.handleDataLoadingError);
            }
            else {
              return Promise.resolve([]);
            }
          }
        });
    }

    

    private handleDataLoadingError(reason: any) {
      let message = 'An error occurred loading data. Please try again, or contact support if the error continues.';
      alert(message, 'Error');
    }

    private sortSelectOptions(data: SelectOption[], descending: boolean = false) {
      let uniqueData = _.uniqBy(data, d => d.value);
      let sortedData = _.sortBy(uniqueData, d => d.text);
      if (descending) {
        sortedData = sortedData.reverse();
      }

      return sortedData;
    }

    show() {
      this.showDialog = true;
    }

    closePopup() {
      this.showDialog = false;
    }

    onHidden() {
      this.reset();
    }

    getPopupHeight(): number {
      return window.innerHeight / 3.0;
    }

    private reset() {
      this.selectedAnalysisClient = null;
      this.selectedAnalysisBatchId = null;
      this.selectedAuditClient = null;
      this.selectedAuditAgents = [];
      this.selectedAuditBatchId = null;
    }

    async displayAnalysisReport() {
      if (this.selectedAnalysisClient == null) {
        alert('Please select a client.', 'Missing selection');

        return;
      }

      if (this.selectedAnalysisBatchId == null) {
        alert('Please select a batch.', 'Missing selection');
        return;
      }
      
      await this.processDownloadOnDemandReports(this.selectedAnalysisBatchId, ReportTypeEnum.Analysis);
    }

    async displayAuditorReport() {          
      if (this.selectedAuditClient == null) {
        alert('Please select a client.', 'Missing selection');
        return;
      }

      if (this.selectedAuditBatchId == null) {
        alert('Please select a batch.', 'Missing selection');
        return;
      }
      
      await this.processDownloadOnDemandReports(this.selectedAuditBatchId, ReportTypeEnum.Auditor);
    }

    async processDownloadOnDemandReports(batchId: string, type: ReportTypeEnum) {          
      let clientName = type === ReportTypeEnum.Auditor ? this.selectedAuditClientName : this.selectedAnalysisClientName;
      let batchName = type === ReportTypeEnum.Auditor ? this.selectedAuditBatchName : this.selectedAnalysisBatchName;
      
      this.downloadInProgress = true;

      let failed: boolean = false;          
      let authorizeDownloadResult = await this.reportService.getReportOnDemand(batchId, this.selectedAuditAgents, type)
        .then((res: any) => {
          return res;
        })
        .catch(reason => {
          failed = true;
          alert('An error occurred generating the report. Please contact support.', 'Error');
          return undefined;
        })
        .finally(() => {
          this.downloadInProgress = false;
        });
      
      if (failed) {
        return;
      }
      
      if (authorizeDownloadResult && authorizeDownloadResult.Url && authorizeDownloadResult.Token) {
        await this.client.download(authorizeDownloadResult.Url, authorizeDownloadResult.Token)
          .then(result => {
            let filename = result.headers.get('Filename');

            result.blob().then((b: any) => {
              FileSaver.saveAs(b, decodeURIComponent(filename));
            });

            if(type === ReportTypeEnum.Auditor) {
              this.processDisplayAgentsWithNoReport(authorizeDownloadResult.Files);
            }
          });
      } else {
          if(this.selectedAuditAgents && this.selectedAuditAgents.length > 0 && type === ReportTypeEnum.Auditor) {
            this.processDisplayAgentsWithNoReport([], true);
          }
          else {
            alert(`${clientName} in ${batchName} didn't have anything to report on.`, 'Report printing cancelled.');
          }
         
      }
    }
    processDisplayAgentsWithNoReport(files: any, hasAllSelected: boolean = false) {
      if(files.length > 0 || hasAllSelected) {
        var selectedAuditAgentNames = ((this.$refs.agentsRef as any).instance as any).getDataSource().items()
                                      .filter((agent : any) => this.selectedAuditAgents.includes(agent.value))
                                      .map((agent : any) => agent.text);

        var displayString = "The following agents had nothing to report on:<br>";
        var agentsWithNoReports: string[] = [];

        _.forEach(selectedAuditAgentNames, agentName => {
          var agentWithReport = _.find(files, item => item.FileName.includes(agentName));
          if(!agentWithReport) {
            agentsWithNoReports.push(`<b>${agentName}</b>`);
          }
        })
        if(agentsWithNoReports.length > 0){
          agentsWithNoReports.forEach((item, index) => {
            var toDisplay = `${item}` + (index < (agentsWithNoReports.length - 1) ? ", " :"");
            if(index && (index % 4 == 0)) {
              toDisplay += "<br>";
            }

            displayString += toDisplay;
          });
          alert(`${displayString}`, 'Agents with nothing to report on.');
        }

      }
    }
}
